"use client";

import React, { useMemo } from "react";
import styles from "../vehile-inventory.module.scss";
import {
  BuyerPreferenceEnum,
  SellerTypeEnum,
  Vehicle,
} from "../../../../../types";
import VehicleCard from "../../card/VehicleCard";
import ClientPagination from "../client-pagination";
import { VehicleContainerProps } from "./props";
import { useCookieListener } from "@/components/package-components/hooks/useCookieListener";
import { motion, AnimatePresence } from "framer-motion";

const listVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

export const VehicleContainer: React.FC<VehicleContainerProps> = ({
  props,
}) => {
  const { cookieValue: buyerPreferenceRaw } = useCookieListener(
    "BuyerPreference",
    { listen: true, intervalMs: 500 }
  );

  const buyerPreference = buyerPreferenceRaw as BuyerPreferenceEnum | undefined;
  const sellerType = props.data.site?.sellerType;

  const vehicles =
    useMemo<Vehicle[] | undefined>(() => {
      if (
        sellerType === SellerTypeEnum.HYBRID &&
        buyerPreference === BuyerPreferenceEnum.ONLY_USED
      ) {
        return props.data.filteredList;
      }

      if (
        sellerType === SellerTypeEnum.HYBRID &&
        buyerPreference === BuyerPreferenceEnum.ONLY_ZERO_KM
      ) {
        return props.data.brandNewVehicleList;
      }

      return props.data.filteredList ?? props.data.vehicleList;
    }, [
      props.data.brandNewVehicleList,
      props.data.filteredList,
      props.data.vehicleList,
      sellerType,
      buyerPreference,
    ]) ?? [];

  return (
    <div className={`${styles.wrapper} wrapper-${props.id}`}>
      {vehicles?.length === 0 && (
        <h1>Nenhum veículo encontrado para a pesquisa</h1>
      )}

      <AnimatePresence mode="wait">
        <motion.div
          key={buyerPreference}
          variants={listVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.3 }}
          className={`${styles["vehicle-container"]} vehicle-container-${props.id}`}
        >
          {vehicles?.map((vehicle, idx) => (
            <VehicleCard
              key={`vehicle-${idx}`}
              id={props.id + vehicle.id}
              vehicle={vehicle}
              options={props.options}
              priority={idx === 0}
              variant={Number(props.cardVariants?.value ?? 1)}
              site={props.data.site}
              currentSlug={props.data.page?.currentSlug}
              props={props}
              buyerPreference={buyerPreference}
            />
          ))}
        </motion.div>
      </AnimatePresence>

      <ClientPagination {...props} />
    </div>
  );
};
